import scrollTo from 'gatsby-plugin-smoothscroll';

export const isExternal = (href) => {
  return href.startsWith('https://');
}

export const smoothScroll = (e, target) => {
  e.preventDefault();
  scrollTo(`${target}`);
}